function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { PropTypes } from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import { ExpertMessageDetail } from "../../../../expert";
import { isMessageEditorState } from "../../..";
import { ExpertConversation, LoadingSpinner } from "../../..";
import ConversationHeader from "../conversation-header/ConversationHeader";
import ConversationFooter from "../conversation-footer/ConversationFooter";
import { calculateFooterAndHeaderHeight, CC_HEIGHT } from "./ConversationDetailHelper";
import Idle from "../../idle/Idle";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { useTranslation } from "@limitless/common/hooks";
import { useExpertProfileContext } from "@limitless/expert";
const useStyles = makeStyles(theme => ({
  wrapper: {
    flexDirection: "column",
    display: "flex",
    flex: 1,
    overflowX: "auto"
  },
  baseContainer: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    position: "relative"
  },
  translationTitlteText: {
    margin: "16px 16px 2px",
    color: theme.palette.grey[4]
  }
}));
const ConversationDetail = ({
  showHeader,
  dialogueSuffixMap,
  dialogueMap,
  scrollOnLoad,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const [resizedFooterAndHeaderHeight, setResizedFooterAndHeaderHeight] = React.useState();
  const {
    isDarkMode
  } = useExpertProfileContext();
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  const handleMessageEditorResize = (e, dir, refToElement, {
    dialogues
  }) => {
    var _dialogues$;
    const transaltionTextContainerHeight = (_dialogues$ = dialogues[0]) !== null && _dialogues$ !== void 0 && _dialogues$.locale ? 2 : 0;
    const amountToAdd = 160 + transaltionTextContainerHeight; //header + conversation title + transalationTextContainer

    setResizedFooterAndHeaderHeight(refToElement.clientHeight + amountToAdd);
  };
  const conversationContainerStyle = ({
    conversationState,
    dialogues
  }) => {
    const transaltionTextContainerHeight = conversationState.showTransaltedLanguageText ? 30 : 0;
    const isEditorMode = isMessageEditorState(conversationState.state);
    let calculatedHeight = isEditorMode && resizedFooterAndHeaderHeight ? resizedFooterAndHeaderHeight : calculateFooterAndHeaderHeight(conversationState);
    if (conversationState.showCustomerConfirmation) {
      calculatedHeight += CC_HEIGHT;
    }
    if (!conversationState.showCustomerConfirmation && dialogues[dialogues.length - 1].type === "custConfirmation") {
      calculatedHeight += CC_HEIGHT;
    }
    return {
      height: `calc(100vh - ${calculatedHeight}px - ${transaltionTextContainerHeight}px)`,
      padding: "2px 0px 0px 16px",
      overflowY: "auto"
    };
  };
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(ExpertMessageDetail, null, ({
    onClaimMessage,
    onAddDialogue,
    onSendAttachment,
    onSendCustomerAttachment,
    onSendCustomerFileAttachment,
    onSwitchToRespond,
    clearMessage,
    loading,
    message,
    profile,
    countryList,
    activityIdleTimeout,
    onTimeoutIncrement,
    translationLanguage
  }) => {
    const showSpinner = loading && (isMessageEditorState(message.conversationState.state) || rest.alwaysShowSpinner);
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper,
      style: {
        background: theme.palette.background.default
      }
    }, showHeader && /*#__PURE__*/React.createElement(ConversationHeader, {
      translationLanguage: translationLanguage,
      message: message,
      clearMessage: clearMessage
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.baseContainer
    }, /*#__PURE__*/React.createElement("div", {
      style: conversationContainerStyle(message)
    }, /*#__PURE__*/React.createElement(ExpertConversation, {
      profile: profile,
      message: message,
      countryList: countryList,
      isParentLoading: loading,
      dialogueSuffixMap: dialogueSuffixMap,
      dialogueMap: dialogueMap,
      lineClamp: rest.lineClamp,
      scrollOnLoad: scrollOnLoad
    })), /*#__PURE__*/React.createElement(ConversationFooter, _extends({
      message: message,
      isParentLoading: loading,
      onClaimMessage: onClaimMessage,
      onAddDialogue: onAddDialogue,
      onResize: (e, dir, refToElement) => handleMessageEditorResize(e, dir, refToElement, message),
      onSendAttachment: onSendAttachment,
      onSendCustomerAttachment: onSendCustomerAttachment,
      onSendCustomerFileAttachment: onSendCustomerFileAttachment,
      onSwitchToRespond: onSwitchToRespond,
      clearMessage: clearMessage
    }, rest)), showSpinner && /*#__PURE__*/React.createElement(LoadingSpinner, {
      overlayParent: true
    }), activityIdleTimeout > 0 && message.claimExtendUIControl && /*#__PURE__*/React.createElement(Idle, {
      timeout: activityIdleTimeout,
      onChange: onTimeoutIncrement,
      defaultIdle: true,
      cancelTimerOnActivity: true,
      cancelTimerOnIdle: false
    }))));
  });
};
export default ConversationDetail;
ConversationDetail.propTypes = {
  showHeader: PropTypes.bool,
  dialogueMap: PropTypes.object,
  dialogueSuffixMap: PropTypes.object,
  scrollOnLoad: PropTypes.bool
};
ConversationDetail.defaultProps = {
  showHeader: true,
  dialogueSuffixMap: {}
};